import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useSkills } from "routes/@lib/skills"
import { useTaskShareLinkCommentReason } from "routes/schedule/plugins/share-link-comments/use-task-share-link-comment-reason"
import { formatCreateTailoredAudit } from "./lib/format-create-tailored-audit"
import { useAutoJustifyFromComment } from "./use-auto-justify-from-comment"

// Auto-saves a task's comment-derived justification once the host changes the task (see
// useAutoJustifyFromComment for the timing/guard rationale). Renders nothing.
export function AutoJustifyFromComment() {
    const {
        task,
        taskTailored,
        tailoringAudit,
        originalTask,
        tailoredTask,
        tailoringReferenceId,
        schedule,
        scheduleItem,
        isEditable = true,
    } = useBoundContext()
    const [skills] = useSkills()
    const commentReason = useTaskShareLinkCommentReason()

    useAutoJustifyFromComment({
        subjectKey: task?.id,
        tailored: taskTailored,
        isHeader: !!task?.isHeader,
        isEditable,
        hasComment: !!commentReason,
        hasExistingReason: !!tailoringAudit?.payload?.reason,
        buildAudit: buildAudit,
    })

    return null

    function buildAudit() {
        return formatCreateTailoredAudit({
            originalTask,
            tailoredTask,
            tailoringReferenceId,
            schedule,
            scheduleItem,
            reason: commentReason,
            skills,
        })
    }
}
